Vue.component('biura-agencyjne-swiat', {
    props: {
        country: { default: '' }
    },
    template: '#vue-biura-agencyjne-swiat',
    data: function () {
        return {
            params: {
                country: ''
            },
            listCountries: [],
            listBiura: [],
            breadcrumbs: [],
            breadcrumbNow: ''
        }
    },
    created: function () {
        const self = this;

        serverBus.$emit('loading_start');

        setCanonicalTag('https://' + location.host + '/biura-na-swiecie');

        self.geCountries();
        self.params.country = self.country;
        self.getBiura(self.country);

        if (self.params.country) {
            setMetaNoIndex(true);
        }

        let title = "Biura na świecie";
        let description = 'Zobacz dane kontaktowe i adresy biur na świecie';
        let keywords = mainMetaKeywordsStatic + ', kontakt, dane kontaktowe, adresy, biuro, biura, świat, kraje';

        if (self.country) {
            title += " - " + self.country;
            description += ' - kraj ' + self.country;
            keywords += ', kraj, ' + self.country;
        }

        setPageTitle(title + mainMetaTitleStatic);
        setMeta("description", description + ' - ' + getMeta("description"));
        setMeta("keywords", keywords);
    },
    watch: {
        'params.country': function (newCountry, oldCountry) {
            if (newCountry != oldCountry) {
                router.replace({
                    name: 'biura-agencyjne-swiat',
                    params: { country: newCountry }
                }).catch(function (err) { });
            }
        }
    },
    methods: {
        geCountries: function () {
            const self = this;
            $.post("/back/BiuraAgencyjneSwiat.php", { action: 'list' }, function (result, textStatus) {
                if (result !== null) {
                    self.listCountries = result;
                }
                serverBus.$emit('loading_end');
            }, "json");
        },
        getBiura: function (country) {
            const self = this;
            $.post("/back/BiuraAgencyjneSwiat.php", { action: 'search', country: country }, function (result, textStatus) {
                if (result !== null) {
                    self.listBiura = result;
                }

                if (self.country) {
                    self.breadcrumbs.push({ text: locales('components.breadcrumbs.biura-agencyjne-swiat'), routeName: 'biura-agencyjne-swiat' });
                    self.breadcrumbNow = self.country;
                } else {
                    self.breadcrumbNow = locales('components.breadcrumbs.biura-agencyjne-swiat');
                }

                serverBus.$emit('loading_end');
            }, "json");
        }
    }
});
